module.exports = __webpack_public_path__ + "static/media/our-team-member-3.0c76fe3d.png";